import React from "react";
import { PIF_LIST_STATUS_LABEL, PifListStatus } from "../../pages/supervision/PostInterviewForm/types";

const STATUS_CLASS: Record<PifListStatus, string> = {
  DRAFT: "postif-chip--draft",
  RETURNED: "postif-chip--returned",
  "PENDING DEPT DIR": "postif-chip--pending",
  "PENDING HR DIR": "postif-chip--pending",
  "PENDING EXEC DIR": "postif-chip--pending",
  APPROVED: "postif-chip--approved",
  COMPLETED: "postif-chip--completed",
  DECLINED: "postif-chip--declined",
};

interface PostIFStatusChipProps {
  status: PifListStatus;
}

const PostIFStatusChip: React.FC<PostIFStatusChipProps> = ({ status }) => (
  <span className={`postif-chip ${STATUS_CLASS[status]}`} data-testid="postif-badge-status">
    {PIF_LIST_STATUS_LABEL[status]}
  </span>
);

export default PostIFStatusChip;
